import { executeGetData, executePostData, executePutData } from "./ApiBase";
import { ConfigUrl } from "../auth/OidcConfig";

export const createProviderConfiguration = async (payload: any, accessToken: any) => {
  const url = `${ConfigUrl.baseURL}/providerConfiguration/createProviderConfiguration`;
  return await executePostData(url, payload, accessToken);
}

export const getProviderConfiguration = async (accessToken: any) => {
  const url = `${ConfigUrl.baseURL}/providerConfiguration/getProviderConfiguration`;
  return await executeGetData(url, accessToken);
}

export const updateProviderConfiguration = async (payload: any, accessToken: any) => {
  const url = `${ConfigUrl.baseURL}/providerConfiguration/updateProviderConfiguration`;
  return await executePutData(url, payload, accessToken);
}